import API from "../../utils/endpoints";
import * as types from "./actionType";
import history from "../../history";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { fetchUserVehicles } from "../user/actions";
const errorMessage = {
  status: 400,
  message: "Something went wrong",
};

function fetchingAllRidesMembership() {
  return {
    type: types.FETCH_RIDES_MEMBERSHIP,
  };
}

function fetchingAllRidesMembershipSuccess(payload, count) {
  return {
    type: types.FETCH_RIDES_MEMBERSHIP_SUCCESS,
    payload,
    count,
  };
}

function fetchingAllRidesMembershipFailed() {
  return {
    type: types.FETCH_RIDES_MEMBERSHIP_FAILED,
  };
}

function fetchingSingleRideMembership() {
  return {
    type: types.FETCH_SINGLE_RIDE_MEMBERSHIP,
  };
}

function fetchingSingleRideMembershipSuccess(payload) {
  return {
    type: types.FETCH_SINGLE_RIDE_MEMBERSHIP_SUCCESS,
    payload,
  };
}

function fetchingSingleRideMembershipFailed() {
  return {
    type: types.FETCH_SINGLE_RIDE_MEMBERSHIP_FAILED,
  };
}

function updatingVinOfUser() {
  return {
    type: types.UPDATE_USER_VIN,
  };
}

function updatingVinOfUserSuccess(payload) {
  return {
    type: types.UPDATE_USER_VIN_SUCCESS,
    payload,
  };
}

function updatingVinOfUserFailed() {
  return {
    type: types.UPDATE_USER_VIN_FAILED,
  };
}

function approvingRideMembership() {
  return {
    type: types.APPROVE_RIDE_MEMBERSHIP,
  };
}

function approvingRideMembershipSuccess(payload) {
  return {
    type: types.APPROVE_RIDE_MEMBERSHIP_SUCCESS,
    payload,
  };
}

function approvingRideMembershipFailed() {
  return {
    type: types.APPROVE_RIDE_MEMBERSHIP_FAILED,
  };
}

function fetchingAllRides() {
  return {
    type: types.FETCH_ALL_RIDES,
  };
}

function fetchingAllRidesSuccess(payload) {
  return {
    type: types.FETCH_ALL_RIDES_SUCCESS,
    payload,
  };
}

function fetchingAllRidesFailed() {
  return {
    type: types.FETCH_ALL_RIDES_FAILED,
  };
}

function fetchingAllReview() {
  return {
    type: types.FETCH_ALL_REVIEW,
  };
}

function fetchingAllReviewSuccess(payload) {
  return {
    type: types.FETCH_ALL_REVIEW_SUCCESS,
    payload,
  };
}

function fetchingAllReviewFailed() {
  return {
    type: types.FETCH_ALL_REVIEW_FAILED,
  };
}

function fetchingSingleRide() {
  return {
    type: types.FETCH_SINGLE_RIDE,
  };
}

function fetchingSingleRideSuccess(payload) {
  return {
    type: types.FETCH_SINGLE_RIDE_SUCCESS,
    payload,
  };
}

function fetchingSingleRideFailed() {
  return {
    type: types.FETCH_SINGLE_RIDE_FAILED,
  };
}

function fetchingCountry() {
  return {
    type: types.FETCH_COUNTRY,
  };
}

function fetchingCountrySuccess(payload) {
  return {
    type: types.FETCH_COUNTRY_SUCCESS,
    payload,
  };
}

function fetchingCountryFailed() {
  return {
    type: types.FETCH_COUNTRY_FAILED,
  };
}

function fetchingState() {
  return {
    type: types.FETCH_STATE,
  };
}

function fetchingStateSuccess(payload) {
  return {
    type: types.FETCH_STATE_SUCCESS,
    payload,
  };
}

function fetchingStateFailed() {
  return {
    type: types.FETCH_STATE_FAILED,
  };
}

function fetchingCity() {
  return {
    type: types.FETCH_CITY,
  };
}

function fetchingCitySuccess(payload) {
  return {
    type: types.FETCH_CITY_SUCCESS,
    payload,
  };
}

function fetchingCityFailed() {
  return {
    type: types.FETCH_CITY_FAILED,
  };
}

function creatingRide() {
  return {
    type: types.CREATE_RIDES,
  };
}

function creatingRideSuccess(payload) {
  return {
    type: types.CREATE_RIDES_SUCCESS,
    payload,
  };
}

function creatingRideFailed() {
  return {
    type: types.CREATE_RIDES_FAILED,
  };
}

function updatingRide() {
  return {
    type: types.UPDATE_RIDES,
  };
}

function updatingRideSuccess(payload) {
  return {
    type: types.UPDATE_RIDES_SUCCESS,
    payload,
  };
}

function updatingRideFailed() {
  return {
    type: types.UPDATE_RIDES_FAILED,
  };
}

function deletingRide() {
  return {
    type: types.DELETE_RIDES,
  };
}

function deletingRideSuccess(payload) {
  return {
    type: types.DELETE_RIDES_SUCCESS,
    payload,
  };
}

function deletingRideFailed() {
  return {
    type: types.DELETE_RIDES_FAILED,
  };
}

function fetchingConsentForm() {
  return {
    type: types.FETCH_CONSENT_FORM,
  };
}

function fetchingConsentFormSuccess(payload) {
  return {
    type: types.FETCH_CONSENT_FORM_SUCCESS,
    payload,
  };
}

function fetchingConsentFormFailed() {
  return {
    type: types.FETCH_CONSENT_FORM_FAILED,
  };
}

function moderatingRides() {
  return {
    type: types.MODERATION_OF_RIDES,
  };
}

function moderatingRidesSuccess(payload) {
  return {
    type: types.MODERATION_OF_RIDES_SUCCESS,
    payload,
  };
}

function moderatingRidesFailed() {
  return {
    type: types.MODERATION_OF_RIDES_FAILED,
  };
}

function fetchingRidesForModeration() {
  return {
    type: types.FETCH_RIDES_FOR_MODERATION,
  };
}

function fetchingRidesForModerationSuccess(payload) {
  return {
    type: types.FETCH_RIDES_FOR_MODERATION_SUCCESS,
    payload,
  };
}

function fetchingRidesForModerationFailed() {
  return {
    type: types.FETCH_RIDES_FOR_MODERATION_FAILED,
  };
}

function fetchingReviewForModeration() {
  return {
    type: types.FETCH_REVIEW_FOR_MODERATION,
  };
}

function fetchingReviewForModerationSuccess(payload) {
  return {
    type: types.FETCH_REVIEW_FOR_MODERATION_SUCCESS,
    payload,
  };
}

function fetchingReviewForModerationFailed() {
  return {
    type: types.FETCH_REVIEW_FOR_MODERATION_FAILED,
  };
}

function fetchingReviewCountry() {
  return {
    type: types.FETCH_REVIEW_COUNTRY,
  };
}

function fetchingReviewCountrySuccess(payload) {
  return {
    type: types.FETCH_REVIEW_COUNTRY_SUCCESS,
    payload,
  };
}

function fetchingReviewCountryFailed() {
  return {
    type: types.FETCH_REVIEW_COUNTRY_FAILED,
  };
}

function fetchingBranch() {
  return {
    type: types.FETCH_BRANCH,
  };
}

function fetchingBranchSuccess(payload) {
  return {
    type: types.FETCH_BRANCH_SUCCESS,
    payload,
  };
}

function fetchingBranchFailed() {
  return {
    type: types.FETCH_BRANCH_FAILED,
  };
}

function fetchingReviewFilter() {
  return {
    type: types.FETCH_REVIEW_FILTER,
  };
}

function fetchingReviewFilterSuccess(payload) {
  return {
    type: types.FETCH_REVIEW_FILTER_SUCCESS,
    payload,
  };
}

function fetchingReviewFilterFailed() {
  return {
    type: types.FETCH_REVIEW_FILTER_FAILED,
  };
}

function fetchingUserForJoinRide() {
  return {
    type: types.FETCH_USER_TO_JOIN_RIDE,
  };
}

function fetchingUserForJoinRideSuccess(payload) {
  return {
    type: types.FETCH_USER_TO_JOIN_RIDE_SUCCESS,
    payload,
  };
}

function fetchingUserForJoinRideFailed() {
  return {
    type: types.FETCH_USER_TO_JOIN_RIDE_FAILED,
  };
}

function moderationForRideUser() {
  return {
    type: types.MODERATION_FOR_USER_RIDE,
  };
}

function moderationForRideUserSuccess(payload) {
  return {
    type: types.MODERATION_FOR_USER_RIDE_SUCCESS,
    payload,
  };
}

function moderationForRideUserFailed() {
  return {
    type: types.MODERATION_FOR_USER_RIDE_FAILED,
  };
}

function joiningNewUser() {
  return {
    type: types.JOIN_NEW_USER,
  };
}

function joiningNewUserSuccess(payload) {
  return {
    type: types.JOIN_NEW_USER_SUCCESS,
    payload,
  };
}

function joiningNewUserFailed() {
  return {
    type: types.JOIN_NEW_USER_FAILED,
  };
}

function fetchingAllUser() {
  return {
    type: types.FETCH_ALL_USERS,
  };
}

function fetchingAllUserSuccess(payload) {
  return {
    type: types.FETCH_ALL_USERS_SUCCESS,
    payload,
  };
}

function fetchingAllUserFailed() {
  return {
    type: types.FETCH_ALL_USERS_FAILED,
  };
}

function exportingToExcel() {
  return {
    type: types.EXPORT_TO_EXCEL,
  };
}

function exportingToExcelSuccess(payload) {
  return {
    type: types.EXPORT_TO_EXCEL_SUCCESS,
    payload,
  };
}

function exportingToExcelFailed() {
  return {
    type: types.EXPORT_TO_EXCEL_FAILED,
  };
}

function exportingToExcelForReview() {
  return {
    type: types.EXPORT_TO_EXCEL_FOR_REVIEW,
  };
}

function exportingToExcelForReviewSuccess(payload) {
  return {
    type: types.EXPORT_TO_EXCEL_FOR_REVIEW_SUCCESS,
    payload,
  };
}

function exportingToExcelForReviewFailed() {
  return {
    type: types.EXPORT_TO_EXCEL_FOR_REVIEW_FAILED,
  };
}

function moderatingRideGallery() {
  return {
    type: types.MODERATION_OF_RIDE_GALLERY,
  };
}

function moderatingRideGallerySuccess(payload) {
  return {
    type: types.MODERATION_OF_RIDE_GALLERY_SUCCESS,
    payload,
  };
}

function moderatingRideGalleryFailed() {
  return {
    type: types.MODERATION_OF_RIDE_GALLERY_FAILED,
  };
}

function fetchingImagesForModeration() {
  return {
    type: types.FETCH_IMAGES_FOR_MODERATION,
  };
}

function fetchingImagesForModerationSuccess(payload) {
  return {
    type: types.FETCH_IMAGES_FOR_MODERATION_SUCCESS,
    payload,
  };
}

function fetchingImagesForModerationFailed() {
  return {
    type: types.FETCH_IMAGES_FOR_MODERATION_FAILED,
  };
}

function fetchingCountryForImageModeration() {
  return {
    type: types.FETCH_COUNTRY_IMAGE_FOR_MODERATION,
  };
}

function fetchingCountryForImageModerationSuccess(payload) {
  return {
    type: types.FETCH_COUNTRY_IMAGE_FOR_MODERATION_SUCCESS,
    payload,
  };
}

function fetchingCountryForImageModerationFailed() {
  return {
    type: types.FETCH_COUNTRY_IMAGE_FOR_MODERATION_FAILED,
  };
}

function fetchingBranchForImageModeration() {
  return {
    type: types.FETCH_BRANCH_IMAGE_FOR_MODERATION,
  };
}

function fetchingBranchForImageModerationSuccess(payload) {
  return {
    type: types.FETCH_BRANCH_IMAGE_FOR_MODERATION_SUCCESS,
    payload,
  };
}

function fetchingBranchForImageModerationFailed() {
  return {
    type: types.FETCH_BRANCH_IMAGE_FOR_MODERATION_FAILED,
  };
}

function fetchingFilterForImageModeration() {
  return {
    type: types.FETCH_FILTER_IMAGE_FOR_MODERATION,
  };
}

function fetchingFilterForImageModerationSuccess(payload) {
  return {
    type: types.FETCH_FILTER_IMAGE_FOR_MODERATION_SUCCESS,
    payload,
  };
}

function fetchingFilterForImageModerationFailed() {
  return {
    type: types.FETCH_FILTER_IMAGE_FOR_MODERATION_FAILED,
  };
}

function moderatingImages() {
  return {
    type: types.MODERATED_IMAGES,
  };
}

function moderatingImagesSuccess(payload) {
  return {
    type: types.MODERATED_IMAGES_SUCCESS,
    payload,
  };
}

function moderatingImagesFailed() {
  return {
    type: types.MODERATED_IMAGES_FAILED,
  };
}

function updatingRideByAdmin() {
  return {
    type: types.UPDATE_RIDE_BY_ADMIN,
  };
}

function updatingRideByAdminSuccess(payload) {
  return {
    type: types.UPDATE_RIDE_BY_ADMIN_SUCCESS,
    payload,
  };
}

function updatingRideByAdminFailed() {
  return {
    type: types.UPDATE_RIDE_BY_ADMIN_FAILED,
  };
}

function clearingPreviousReducer() {
  return {
    type: types.CLEAR_PREVIOUS_REDUCERS,
  };
}

function gettingActivityForReview() {
  return {
    type: types.ACTIVITY_FOR_REVIEW,
  };
}

function gettingActivityForReviewSuccess(payload) {
  return {
    type: types.ACTIVITY_FOR_REVIEW_SUCCESS,
    payload,
  };
}

function gettingActivityForReviewFailed() {
  return {
    type: types.ACTIVITY_FOR_REVIEW_FAILED,
  };
}

function gettingActivityForGallery() {
  return {
    type: types.ACTIVITY_FOR_GALLERY,
  };
}

function gettingActivityForGallerySuccess(payload) {
  return {
    type: types.ACTIVITY_FOR_GALLERY_SUCCESS,
    payload,
  };
}

function gettingActivityForGalleryFailed() {
  return {
    type: types.ACTIVITY_FOR_GALLERY_FAILED,
  };
}

//****** clearPreviousReducer  ********//

export const clearPreviousReducer = (payload) => async (dispatch) => {
  dispatch(clearingPreviousReducer());
};

//****** fetchAllRidesMembership  ********//

export const fetchAllRidesMembership = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingAllRidesMembership());
  try {
    let response = await api.get(
      `${API.fetchAllRidesMembership}?status=${payload.status}&page=${payload.page}&limit=${payload.count}&mobile=${payload.phone}&email=${payload.email}&startDate=${payload.startDate}&endDate=${payload.endDate}&name=${payload.firstName}&vin=${payload.vin}`
    );
    if (response.data.code === 200) {
      dispatch(
        fetchingAllRidesMembershipSuccess(
          response.data.data,
          response.data.count
        )
      );
    } else {
      dispatch(fetchingAllRidesMembershipFailed());
    }
  } catch (error) {
    dispatch(fetchingAllRidesMembershipFailed(errorMessage));
  }
};

//****** fetchAllRidesMembership  ********//

export const fetchSingleRideMembership = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingSingleRideMembership());
  try {
    let response = await api.get(
      `${API.fetchSingleRideMembership}?formId=${payload}`
    );
    if (response.data.code === 200) {
      dispatch(fetchingSingleRideMembershipSuccess(response.data.data));
      if (response.data.data.userID !== null) {
        dispatch(fetchConsentForm(response.data.data.userID._id));
      }
    } else {
      dispatch(fetchingSingleRideMembershipFailed());
    }
  } catch (error) {
    dispatch(fetchingSingleRideMembershipFailed(errorMessage));
  }
};

//** Moderate event gallery */

export const rideGallery = (payload) => async (dispatch, getState, api) => {
  dispatch(moderatingRideGallery());
  try {
    let response = await api.post(API.moderateEventGallery, payload);
    if (response.data.code === 200) {
      dispatch(moderatingRideGallerySuccess(response.data.data));
      toast.error(response.data.message);
    } else {
      dispatch(moderatingRideGalleryFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(moderatingRideGalleryFailed(errorMessage));
  }
};

//****** Update Vin  ********//

export const updateVinOfUser = (payload) => async (dispatch, getState, api) => {
  dispatch(updatingVinOfUser());
  console.log("payload", payload);
  try {
    let response = await api.put(API.updateVinOfUser, payload);
    if (response.data.code === 200) {
      dispatch(updatingVinOfUserSuccess(response.data.data));
      dispatch(fetchUserVehicles(payload.userID));
      if (response.data.data.userID !== null) {
        dispatch(fetchSingleRideMembership(payload.guid));
      }
      // if (response.data.data.vinDuplicate === true) {
      //   toast.error("Duplicate Vin");
      // }
    } else {
      dispatch(updatingVinOfUserFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(updatingVinOfUserFailed(errorMessage));
  }
};

//****** Fetch Consent form  ********//

export const fetchConsentForm = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingConsentForm());
  try {
    let response = await api.get(`${API.fetchConsentForm}?userId=${payload}`);
    if (response.data.code === 200) {
      dispatch(fetchingConsentFormSuccess(response.data.data));
    } else {
      dispatch(fetchingConsentFormFailed());
    }
  } catch (error) {
    dispatch(fetchingConsentFormFailed(errorMessage));
  }
};

//****** approvingRideMembership  ********//

export const approveRideMembership = (payload, reqObj) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(approvingRideMembership());
  try {
    let response = await api.post(API.approveRideMembership, payload);
    if (response.data.code === 200) {
      dispatch(clearingPreviousReducer());
      dispatch(approvingRideMembershipSuccess(response.data.data));
      dispatch(fetchSingleRideMembership(payload.formId));
      dispatch(fetchAllRidesMembership(reqObj));

      toast.error(response.data.message);
    } else {
      dispatch(approvingRideMembershipFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(approvingRideMembershipFailed(errorMessage));
  }
};

//****** fetchAllRide  ********//

export const fetchAllRide = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingAllRides());
  try {
    let response = await api.get(API.fetchAllRide);
    if (response.data.code === 200) {
      dispatch(fetchingAllRidesSuccess(response.data.data));
    } else {
      dispatch(fetchingAllRidesFailed());
    }
  } catch (error) {
    dispatch(fetchingAllRidesFailed(errorMessage));
  }
};

//****** fetchAllReview ********//

export const fetchAllReviews = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingAllReview());
  try {
    let response = await api.get(API.fetchAllReview);
    console.log(response);
    alert("response");
    if (response.data.code === 200) {
      alert("Executing");
      console.log("Cheking data", response.data.data);

      dispatch(fetchingAllReviewSuccess(response.data.data));
    } else {
      dispatch(fetchingAllReviewFailed());
    }
  } catch (error) {
    dispatch(fetchingAllReviewFailed(errorMessage));
  }
};

//****** fetchSingleRide  ********//

export const fetchSingleRide = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingSingleRide());
  try {
    let response = await api.get(`${API.fetchSingleRide}?rideId=${payload}`);
    if (response.data.code === 200) {
      dispatch(fetchingSingleRideSuccess(response.data.data));
    } else {
      dispatch(fetchingSingleRideFailed());
    }
  } catch (error) {
    dispatch(fetchingSingleRideFailed(errorMessage));
  }
};

//****** Fetching Country  ********//

export const fetchRideCountry = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingCountry());
  try {
    let response = await api.get(
      `${API.fetchRideCountry}?status=${payload.status}&category=${payload.category}`
    );
    if (response.data.code === 200) {
      dispatch(fetchingCountrySuccess(response.data.data));
    } else {
      dispatch(fetchingCountryFailed());
    }
  } catch (error) {
    dispatch(fetchingCountryFailed(errorMessage));
  }
};

//****** Fetching State  ********//

export const fetchRideState = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingState());
  try {
    let response = await api.get(`${API.fetchRideState}?country=${payload}`);

    if (response.data.code === 200) {
      dispatch(fetchingStateSuccess(response.data.data));
    } else {
      dispatch(fetchingStateFailed());
    }
  } catch (error) {
    dispatch(fetchingStateFailed(errorMessage));
  }
};

//****** Fetching City  ********//

export const fetchRideCity = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingCity());
  try {
    let response = await api.get(
      `${API.fetchRideCity}?country=${payload.countryCode}&state=${payload.state}`
    );

    if (response.data.code === 200) {
      dispatch(fetchingCitySuccess(response.data.data));
    } else {
      dispatch(fetchingCityFailed());
    }
  } catch (error) {
    dispatch(fetchingCityFailed(errorMessage));
  }
};

//****** createRide  ********//

export const createRide = (payload) => async (dispatch, getState, api) => {
  dispatch(creatingRide());

  try {
    let response = await api.post(API.createRide, payload);
    if (response.data.code === 200) {
      dispatch(creatingRideSuccess(response.data.data));
      history.push("/rides/list");
      toast.error(response.data.message);
    } else {
      dispatch(creatingRideFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(creatingRideFailed(errorMessage));
  }
};

//****** updateRide  ********//

export const updateRide = (payload) => async (dispatch, getState, api) => {
  dispatch(updatingRide());

  try {
    let response = await api.post(API.updateRide, payload);
    if (response.data.code === 200) {
      dispatch(updatingRideSuccess(response.data.data));
      history.push("/rides/list");
      toast.error(response.data.message);
    } else {
      dispatch(updatingRideFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(updatingRideFailed(errorMessage));
  }
};

//****** deleteRide  ********//

export const deleteRide = (payload) => async (dispatch, getState, api) => {
  dispatch(deletingRide());
  try {
    let response = await api.post(API.deleteRide, payload);
    if (response.data.code === 200) {
      dispatch(deletingRideSuccess(response.data.data));
      toast.error(response.data.message);
    } else {
      dispatch(deletingRideFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(deletingRideFailed(errorMessage));
  }
};

//****** Fetch Rides for Moderation ********//

export const fetchRidesForModeration = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingRidesForModeration());
  try {
    let response = await api.get(
      `${API.fetchRidesForModeration}?status=${payload}`
    );
    if (response.data.code === 200) {
      dispatch(fetchingRidesForModerationSuccess(response.data.data));
    } else {
      dispatch(fetchingRidesForModerationFailed());
    }
  } catch (error) {
    dispatch(fetchingRidesForModerationFailed(errorMessage));
  }
};

export const fetchReviewForModeration = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingReviewForModeration());
  try {
    let response = await api.get(
      `${API.fetchReviewForModeration}?status=${payload.status}&branchId=${payload.branchId}&country=${payload.countryCode}&category=${payload.category}`
    );
    if (response.data.code === 200) {
      dispatch(fetchingReviewForModerationSuccess(response.data.data));
    } else {
      dispatch(fetchingReviewForModerationFailed());
    }
  } catch (error) {
    dispatch(fetchingReviewForModerationFailed(errorMessage));
  }
};

export const fetchReviewCountry = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingReviewCountry());
  try {
    let response = await api.get(
      `${API.fetchReviewCountry}?moderationStatus=${payload.status}&category=${payload.category}`
    );
    if (response.data.code === 200) {
      dispatch(fetchingReviewCountrySuccess(response.data.data));
    } else {
      dispatch(fetchingReviewCountryFailed());
    }
  } catch (error) {
    dispatch(fetchingReviewCountryFailed(errorMessage));
  }
};

export const fetchBranch = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingBranch());
  try {
    let response = await api.get(
      `${API.fetchBranch}?moderationStatus=${payload.status}&category=${payload.category}&countryCode=${payload.countryCode}`
    );
    if (response.data.code === 200) {
      dispatch(fetchingBranchSuccess(response.data.data));
    } else {
      dispatch(fetchingBranchFailed());
    }
  } catch (error) {
    dispatch(fetchingBranchFailed(errorMessage));
  }
};

export const fetchReviewFilter = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingReviewFilter());
  try {
    let response = await api.get(
      `${API.fetchReviewFilter}?moderationStatus=${payload.status}&category=${payload.category}&countryCode=${payload.countryCode}&branchId=${payload.branchId}&activityId=${payload.activityId}`
    );
    if (response.data.code === 200) {
      dispatch(fetchingReviewFilterSuccess(response.data.data));
    } else {
      dispatch(fetchingReviewFilterFailed());
    }
  } catch (error) {
    dispatch(fetchingReviewFilterFailed(errorMessage));
  }
};

//****** Moderation of Rides ********//

export const moderateRides = (payload, status) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(moderatingRides());
  try {
    let response = await api.post(API.moderateRides, payload);
    if (response.data.code === 200) {
      dispatch(moderatingRidesSuccess(response.data.data));
      dispatch(fetchRidesForModeration(status));
      toast.error(response.data.message);
    } else {
      dispatch(moderatingRidesFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(moderatingRidesFailed(errorMessage));
  }
};

//****** Fetch User for Join Ride  ********//

export const fetchUserForJoinRide = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingUserForJoinRide());
  try {
    let response = await api.get(
      `${API.fetchUserForJoinRide}?activityId=${payload.id}&moderationStatus=${payload.status}`
    );
    if (response.data.code === 200) {
      dispatch(fetchingUserForJoinRideSuccess(response.data.data));
    } else {
      dispatch(fetchingUserForJoinRideFailed());
    }
  } catch (error) {
    dispatch(fetchingUserForJoinRideFailed(errorMessage));
  }
};

//****** Fetching User  ********//

export const fetchAllUser = (payload) => async (dispatch, getState, api) => {
  dispatch(fetchingAllUser());
  try {
    let response = await api.get(
      `${API.fetchAllUser}?phone=${payload.mobile}&email=${payload.email}`
    );

    if (response.data.code === 200) {
      dispatch(fetchingAllUserSuccess(response.data.data));
    } else {
      dispatch(fetchingAllUserFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(fetchingAllUserFailed(errorMessage));
  }
};

//****** Fetch User for Join Ride  ********//

export const moderateUserForRide = (payload) => async (
  dispatch,
  getState,
  api
) => {
  let data = {
    status: "PENDING",
    id: payload.rideId,
  };
  dispatch(moderationForRideUser());
  try {
    let response = await api.post(API.fetchUserForJoinRide, payload);
    if (response.data.code === 200) {
      dispatch(moderationForRideUserSuccess(response.data.data));
      dispatch(fetchUserForJoinRide(data));
      toast.error(response.data.message);
    } else {
      dispatch(moderationForRideUserFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(moderationForRideUserFailed(errorMessage));
  }
};

//****** Join New User  ********//

export const joinNewUser = (payload) => async (dispatch, getState, api) => {
  dispatch(joiningNewUser());
  try {
    let response = await api.post(API.joinNewUser, payload);
    if (response.data.code === 200) {
      dispatch(joiningNewUserSuccess(response.data.data));
      toast.error(response.data.message);
    } else {
      dispatch(joiningNewUserFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(joiningNewUserFailed(errorMessage));
  }
};

//******  EXPORT_TO_EXCEL ********//

export const exportToExcel = (payload) => async (dispatch, getState, api) => {
  dispatch(exportingToExcel());
  try {
    let response = await api.post(API.exportToExcelClubMember, payload);

    if (response.data.code === 200) {
      dispatch(exportingToExcelSuccess(response.data.data));
      toast.error(response.data.message);
    } else {
      dispatch(exportingToExcelFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(exportingToExcelFailed(errorMessage));
  }
};

export const exportToExcelForReview = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(exportingToExcelForReview());
  try {
    let response = await api.post(API.exportToExcelForReview, payload);

    if (response.data.code === 200) {
      dispatch(exportingToExcelForReviewSuccess(response.data.data));
      toast.error(response.data.message);
    } else {
      dispatch(exportingToExcelForReviewFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(exportingToExcelForReviewFailed(errorMessage));
  }
};

//****** Fetch Image For Ride   ********//

export const fetchImagesForModeration = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingImagesForModeration());
  try {
    let response = await api.get(
      `${API.fetchImagesForModeration}?category=${payload.category}&moderationStatus=${payload.status}&countryCode=${payload.countryCode}&branchId=${payload.branchId}&activityId=${payload.activityId}`
    );
    if (response.data.code === 200) {
      dispatch(fetchingImagesForModerationSuccess(response.data.data));
    } else {
      dispatch(fetchingImagesForModerationFailed());
    }
  } catch (error) {
    dispatch(fetchingImagesForModerationFailed(errorMessage));
  }
};

export const handleFetchImageCountry = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingCountryForImageModeration());
  try {
    let response = await api.get(
      `${API.fetchCountryForImageModeration}?moderationStatus=${payload.status}&category=${payload.category}`
    );
    if (response.data.code === 200) {
      dispatch(fetchingCountryForImageModerationSuccess(response.data.data));
    } else {
      dispatch(fetchingCountryForImageModerationFailed());
    }
  } catch (error) {
    dispatch(fetchingCountryForImageModerationFailed(errorMessage));
  }
};

export const handleFetchImageBranch = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingBranchForImageModeration());
  try {
    let response = await api.get(
      `${API.fetchBranchForImageModeration}?moderationStatus=${payload.status}&category=${payload.category}&countryCode=${payload.countryCode}`
    );
    if (response.data.code === 200) {
      dispatch(fetchingBranchForImageModerationSuccess(response.data.data));
    } else {
      dispatch(fetchingBranchForImageModerationFailed());
    }
  } catch (error) {
    dispatch(fetchingBranchForImageModerationFailed(errorMessage));
  }
};

export const handleFetchImageFilter = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(fetchingFilterForImageModeration());
  try {
    let response = await api.get(
      `${API.fetchFilterForImageModeration}?moderationStatus=${payload.status}&category=${payload.category}&countryCode=${payload.countryCode}&branchId=${payload.branchId}`
    );
    if (response.data.code === 200) {
      dispatch(fetchingFilterForImageModerationSuccess(response.data.data));
    } else {
      dispatch(fetchingFilterForImageModerationFailed());
    }
  } catch (error) {
    dispatch(fetchingFilterForImageModerationFailed(errorMessage));
  }
};

//******  Moderate Image ********//

export const moderateRideImages = (payload, reqObj, type) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(moderatingImages());
  try {
    let response = await api.post(API.moderateRideImages, payload);
    console.log(response);
    if (response.data.code === 200) {
      dispatch(moderatingImagesSuccess(response.data));
      if (type === "all") {
        dispatch(fetchImagesForModeration(reqObj));
      }
      toast.error(response.data.message);
    } else {
      dispatch(moderatingImagesFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(moderatingImagesFailed(errorMessage));
  }
};

//****** adminUpdateRide  ********//

export const updateRideByAdmin = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(updatingRideByAdmin());
  try {
    let response = await api.put(API.updateRideByAdmin, payload);
    if (response.data.code === 200) {
      dispatch(updatingRideByAdminSuccess(response.data.data));
      history.push("/rides/moderation");
      toast.error(response.data.message);
    } else {
      dispatch(updatingRideByAdminFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(updatingRideByAdminFailed(errorMessage));
  }
};

//****** getActivityForReview  ********//

export const getActivityForReview = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(gettingActivityForReview());
  try {
    let response = await api.get(
      `${API.getActivityForReview}?category=${payload.category}&countryCode=${payload.countryCode}&branchId=${payload.branchId}`
    );
    if (response.data.code === 200) {
      dispatch(gettingActivityForReviewSuccess(response.data.data));
    } else {
      dispatch(gettingActivityForReviewFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(gettingActivityForReviewFailed(errorMessage));
  }
};

//****** getActivityForGallery  ********//

export const getActivityForGallery = (payload) => async (
  dispatch,
  getState,
  api
) => {
  dispatch(gettingActivityForGallery());
  try {
    let response = await api.get(
      `${API.getActivityForGallery}?category=${payload.category}&countryCode=${payload.countryCode}&branchId=${payload.branchId}`
    );
    if (response.data.code === 200) {
      dispatch(gettingActivityForGallerySuccess(response.data.data));
    } else {
      dispatch(gettingActivityForGalleryFailed());
      toast.error(response.data.message);
    }
  } catch (error) {
    dispatch(gettingActivityForGalleryFailed(errorMessage));
  }
};
